// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"81f3edf6","229":"3ff82fbb","410":"4657e255","572":"2eb65a1b"}[chunkId] + ".chunk.js";
};